var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('h1',[_vm._v(_vm._s(_vm.getMessage('MSG_OCURRIO_ERROR')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }